export default {
    data: {},
    platformFeatures: null,

    vendorProducts:[],
    vendors:[]
}
